import React, { useState } from 'react';

const PhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.04 1.18 2 2 0 012.03 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" />
  </svg>
);

const MailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const PinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

const contactItems = [
  {
    icon: <PinIcon />,
    label: 'Standort Hamburg',
    value: <>Hinter der Schule 2<br />22145 Stapelfeld</>,
  },
  {
    icon: <PinIcon />,
    label: 'Standort Bremen',
    value: <>Achterdiek 160<br />28325 Bremen</>,
  },
  {
    icon: <PhoneIcon />,
    label: 'Telefon Hamburg',
    value: <a href="tel:04018230400">040 18230400</a>,
  },
  {
    icon: <PhoneIcon />,
    label: 'Telefon Bremen',
    value: <a href="tel:01604108080">0160 4108080</a>,
  },
  {
    icon: <MailIcon />,
    label: 'E-Mail',
    value: <a href="mailto:info@huusmacher.de">info@huusmacher.de</a>,
  },
];

export default function KontaktSection() {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const name    = form.name.value;
    const email   = form.email.value;
    const subject = form.subject.value;
    const message = form.message.value;
    window.location.href =
      `mailto:info@huusmacher.de?subject=${encodeURIComponent(subject || 'Kontaktanfrage von ' + name)}&body=${encodeURIComponent(`Name: ${name}\nE-Mail: ${email}\n\n${message}`)}`;
    setSent(true);
  };

  return (
    <section className="section section--alt" id="kontakt">
      <div className="container">

        <span className="section-label">Schreiben Sie uns</span>
        <div className="kontakt2__inner">

          {/* Linke Spalte: Kontaktinfos */}
          <div>
            <h2 className="kontakt2__info-title">Persönliche Beratung auf Augenhöhe</h2>
            <p className="kontakt2__info-sub">
              Ob Frage zum Projekt, Kostenschätzung oder einfach erste Orientierung –
              wir antworten innerhalb eines Werktages.
            </p>
            <div className="kontakt2__items">
              {contactItems.map((item, i) => (
                <div key={i} className="kontakt2__item">
                  <div className="kontakt2__item-icon">{item.icon}</div>
                  <div>
                    <div className="kontakt2__item-label">{item.label}</div>
                    <div className="kontakt2__item-value">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Rechte Spalte: Formular */}
          <div className="kontakt2__form">
            {sent ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
                <h3 style={{ color: 'var(--dark)', marginBottom: 8 }}>Ihr E-Mail-Programm wurde geöffnet.</h3>
                <p style={{ color: 'var(--muted)', fontSize: 15 }}>
                  Bitte senden Sie die vorbereitete Nachricht ab – wir melden uns bald.
                </p>
              </div>
            ) : (
              <>
                <h3 className="kontakt2__form-title">Nachricht senden</h3>
                <p className="kontakt2__form-sub">Alle Felder sind freiwillig – außer Ihrer E-Mail.</p>
                <form onSubmit={handleSubmit}>
                  <div className="kontakt2__row">
                    <div className="kontakt2__group">
                      <label className="kontakt2__label">Ihr Name</label>
                      <input name="name" className="kontakt2__input" type="text" placeholder="Max Mustermann" />
                    </div>
                    <div className="kontakt2__group">
                      <label className="kontakt2__label">E-Mail *</label>
                      <input name="email" className="kontakt2__input" type="email" placeholder="max@beispiel.de" required />
                    </div>
                  </div>
                  <div className="kontakt2__group">
                    <label className="kontakt2__label">Betreff</label>
                    <input name="subject" className="kontakt2__input" type="text" placeholder="Beratung Energetische Sanierung" />
                  </div>
                  <div className="kontakt2__group">
                    <label className="kontakt2__label">Ihre Nachricht</label>
                    <textarea name="message" className="kontakt2__textarea" placeholder="Beschreiben Sie kurz Ihr Projekt oder Ihre Frage …" />
                  </div>
                  <button type="submit" className="btn btn-primary kontakt2__submit">
                    Nachricht senden →
                  </button>
                  <p className="kontakt2__note">
                    Dies öffnet Ihr E-Mail-Programm mit den ausgefüllten Daten.
                  </p>
                </form>
              </>
            )}
          </div>

        </div>
      </div>
    </section>
  );
}
